import { postRequest } from "../config/AxiosConfig";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import API_URLS from "../config/BackendConfig";

import { storeToken, getToken } from "../utils/tokenUtils";
import Cookies from "js-cookie";

const prodBaseUrl = API_URLS.PROD;

export const logout = async () => {
  const token = getToken();
  const response = await postRequest({
    url: `${API_URLS.CUSTOMER}logout`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const getLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ latitude, longitude });
        },
        (error) => {
          reject(new Error("Location access denied or unavailable."));
        },
      );
    } else {
      reject(new Error("Geolocation is not supported by this browser."));
    }
  });
};

//  login and verifyPin functions, ensure only .set is used.
export const login = async ({ user_id, password, latitude, longitude }) => {
  try {
    console.time("location");

    // const { latitude, longitude } = await getLocation();

    console.timeEnd("location");

    const response = await postRequest({
      url: API_URLS.CUSTOMER + "login",
      data: { user_id, password }, // Pass lat/long to API
      headers: {
        Latitude: latitude,
        Longitude: longitude,
      },
    });

    const data = response;
    if (data.accessToken) {
      const token = data.accessToken;
      storeToken(token); // Store token in cookies or local storage
      return {
        success: true,
        data: data,
        message: "Logged In Successfully!",
      };
    }
    return {
      success: false,
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message:
        error.message === "Location access denied or unavailable."
          ? "Please enable location services."
          : "Invalid login attempt.",
    };
  }
};

//Login with otp
export const loginWithOtp = async ({ user_id }) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/login-otp",
      data: { user_id },
    });

    const data = response;
    return {
      success: true,
      data: data,
      message: "OTP sent successfully!",
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Failed to send OTP.",
    };
  }
};

// Validate Login OTP
export const validateLoginOtp = async ({ temp_token, otp, reference_id }) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/verify-otp",
      data: { temp_token, otp, reference_id },
    });

    // ✅ If backend returns token, login is successful
    if (response.token) {
      return {
        success: true,
        data: response,
        message: response.message || "Logged In Successfully!",
      };
    }

    // ❌ If no token, OTP is invalid
    return {
      success: false,
      data: response,
      message: response.message || "Invalid OTP or login attempt.",
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Server error. Invalid OTP or login attempt.",
    };
  }
};

// {
//     "email_address": "testi@gmail.com",
//     "mobile_number": 9354186582,
//     "password": "password",
//     "confirm_password": "password",
//     "website_login": true,
//     "company_domain": "test.com"
// }
// signUpValidate Service

export const signUpValidate = async (payload) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/web/validate",
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Sign Up Validation Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// with option after validation
// {
//     "email_address": "testi@gmail.com",
//     "mobile_number": 9354186582,
//     "password": "password",
//     "confirm_password": "password",
//     "website_login": true,
//     "company_domain": "test.com",
//     "otp": 403110,
//     "reference_id": "b8729c0e-1188-4fed-a307-4120f30eb0da"
// }

export const signUpWithOptions = async (payload) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/web/signup",
      data: payload,
    });
    return response;
  } catch (error) {
    console.error("Sign Up Error:", error.response?.data || error.message);
    throw error;
  }
};

//fetch-company-types
export const fetchCompanyTypes = async () => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/fetch-company-types",
    });
    return response;
  } catch (error) {
    console.error(
      "Error fetching company types:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

//  Document List
export const fetchDocumentList = async () => {
  try {
    const token = getToken();
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/document-list",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error(
      "Error fetching document list:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// step 1st business Details
// {
//     "company_gst_no": "1234567890",
//     "company_cin": "1234567890",
//     "company_name": "Company Name New",
//     "company_domain": "Company Domain",
//     "company_type_id": 1,
//     "line_of_business": "Line of Business",
//     "business_description": "Business Description"
// }

export const submitBusinessDetails = async (payload) => {
  try {
    const token = getToken();
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/business-details",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error(
      "Error submitting business details:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Company CIN Verify Service SignUp
export const companyCinVerifySignUp = async ({ payload }) => {
  try {
    const token = getToken();
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/validate/cin",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// step 2nd Signatory Details
// {
//     "name": "John Doe Updated",
//     "aadhar_number": "123856789012",
//     "pan_number": "ABCD1234X",
//     "mobile_number": "1234767890",
//     "email_address": "johnm.doe@example.com",
//     "landmark_address": "123 Main St, Anytown, USA",
//     "aadhar_response": {
//         "name": "John Doe",
//         "dob": "1990-01-01",
//         "gender": "Male",
//         "address": "123 Main St, Anytown, USA",
//         "photo": "https://example.com/photo.jpg"
//     },
//     "pan_response": {
//         "name": "John Doe",
//         "dob": "1990-01-01",
//         "gender": "Male",
//         "address": "123 Main St, Anytown, USA",
//         "photo": "https://example.com/photo.jpg"
//     }
// }
export const submitSignatoryDetails = async (payload) => {
  try {
    const token = getToken();
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/signatory-details",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error(
      "Error submitting signatory details:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// 3rd Step Document Upload
// document_id
// file

export const uploadDocument = async (payload) => {
  try {
    const token = getToken();
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/upload-documents",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error(
      "Error uploading document:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

const handleAuthError = (error) => {
  if (error.response) {
    const errorMessage = error.response.data.message || "Login failed!";
    showErrorToast(`Error ${error.response.status}: ${errorMessage}`);
  } else if (error.request) {
    showErrorToast("No response received from server");
  } else {
    showErrorToast(`Error: ${error.message}`);
  }
};

export const verifyPin = async (pin, tempToken, latitude, longitude) => {
  try {
    // const { latitude, longitude } = await getLocation();

    const response = await postRequest({
      url: `${API_URLS.CUSTOMER}verify-pin`,
      data: { pin, temp_token: tempToken, latitude, longitude }, // Pass lat/long to API
      headers: {
        Authorization: `Bearer ${tempToken}`, // Include tempToken in the header
      },
    });

    if (response.token) {
      const token = response.token;
      Cookies.set("authTokenUser", token, { expires: 0.125 }); // Store token in cookies for 3 hours
      showSuccessToast("PIN Verified Successfully");

      return {
        success: true,
        message: "PIN Verified Successfully",
        token, // Return the token if needed
      };
    }

    showErrorToast(response.message || "Invalid PIN");
    return {
      success: false,
      message: response.message || "Invalid PIN",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.message === "Location access denied or unavailable."
          ? "Please enable location services."
          : "Server error occurred while verifying PIN.",
    };
  }
};

// Show Login News Read
export const NewsService = async () => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/fetch/user-login-news",
    });
    return response;
  } catch (error) {
    console.error(
      "Error In Fetching News ",
      error.response?.data || error.message,
    );
  }
};
//ENd

// Show Login Banner Image
export const BannerService = async () => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/fetch/user-login-banner",
    });
    return response;
  } catch (error) {
    console.error(
      "Error in fetching Banner Image",
      error.response?.data || error.message,
    );
  }
};
// ENd

export const ForgotPasswordGetOtp = async (payload) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/forgot-password",
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in fetching Banner Image",
      error.response?.data || error.message,
    );
  }
};

export const ForgotPasswordVerifyOtp = async (payload) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/forgot-password/verify-otp",
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in fetching Banner Image",
      error.response?.data || error.message,
    );
  }
};

export const ForgotPasswordReset = async (payload) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/forgot-password/reset",
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in fetching Banner Image",
      error.response?.data || error.message,
    );
  }
};
export const ForgotPinReset = async (payload) => {
  try {
    const response = await postRequest({
      url: "https://javabackend.idspay.in/api/v1/customer/reset/pin",
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in fetching Banner Image",
      error.response?.data || error.message,
    );
  }
};
